module.exports = __webpack_public_path__ + "static/media/who-8.3c025c6d.jpg";